import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// Old vertical URLs forward to their shared funnel, keeping ?aff= / ?b= etc.
export default function LegacyFunnelRedirect({ to }) {
  const { search } = useLocation();
  return <Navigate to={`/lp/${to}${search}`} replace />;
}
